import React from "react";
import imgTestata from "../../assets/testate/testata3.jpg";
import Testata from "../../components/Testata/Testata";
import imgService1 from "../../assets/servizi/img1.jpeg";
import imgService2 from "../../assets/servizi/img2.jpg";
import imgService3 from "../../assets/servizi/img3.jpg";
import Cta from "../../components/Cta/Cta";
import GalleryV from "../../components/Gallery/GalleryV";
import GalleryTestata from "../../components/Gallery/GalleryTestata";

const Servizi = () => {
  return (
    <div>
      <GalleryTestata
        arrayFoto={["L1180280", "L1180296"]}
        titoloGallery="Azienda"
      />
      <div className="pt">
        <div className="container">
          <div className="intro text-center mb0">
            <h2>Servizi</h2>
            <p className="">
              L'impianto elettrico al giorno d'oggi non può essere realizzato
              senza l'utilizzo di componenti elettroniche che ne aumentano le
              potenzialità e semplificano la nostra vita ottimizzando anche i
              consumi. Con la nostra competenza ed esperienza nel settore
              sapremo fornirti la soluzione più adatta a te e al miglior prezzo!
            </p>
            <h3 className="lead mb0">Scopri come possiamo aiutarti:</h3>
          </div>
        </div>
      </div>
      <div className="fluid-list">
        <div className="fluid-row">
          <div className="fluid-img">
            <GalleryV
              arrayFoto={["L1180197", "L1180200", "L1180219", "L1180205"]}
              titoloGallery="Quadri elettrici industriali"
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <h2>Quadri elettrici industriali</h2>
              <p>
                Ci occupiamo della gestione tecnica delle attività legate agli
                impianti elettrici/manutenzioni e Realizzazione Q.E. nello
                specifico:
                <br />
                <br />
                • Acquisizione Clienti <br />
                • Acquisizione Fornitori per acquisto materiale
                <br />
                • Prepara le specifiche tecniche relative alle offerte di
                impianti/manutenzioni/Q.E. pervenute
                <br />
                • Analizzare, con i Responsabili di Manutenzione, le offerte
                relative ai nuovi progetti/nuovi impianti
                <br />
                • Segue le imprese elettriche durante l’esecuzione di lavori e
                supervisionare gli eventuali collaudi
                <br />
                • Collabora con i Responsabili all’analisi delle problematiche
                inerenti agli impianti esistenti, contribuendo alla loro
                ottimizzazione
                <br />
                • Progetta nuovi schemi elettrici attraverso l’utilizzo Autocad
                <br />
                • Preventivi
                <br />
                • Gestione Cantiere
                <br />
                • Contabilità
                <br />
              </p>
            </div>
          </div>
        </div>
        <div className="fluid-row">
          <div className="fluid-img">
            <GalleryV
              arrayFoto={["L1180232", "L1180236", "L1180287", "L1180239"]}
              titoloGallery="Officina meccanica"
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <h2>Officina meccanica</h2>
              <p>
                Si occupa della produzione, montaggio e assemblaggio componenti
                meccanici, strutture metalliche, carpenteria leggera, nel
                rispetto degli standard qualitativi richiesti; ottimizza le
                risorse e i mezzi di produzione in un’ottica di riduzione dei
                costi; stabilisce i tempi di lavorazione.
              </p>
            </div>
          </div>
        </div>

        <div className="fluid-row">
          <div className="fluid-img">
            <img src={imgService3} alt="Servizi Italimpianti" />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <h2>Edilizia</h2>
              <p>
                Ci occupiamo della gestione tecnica delle attività legate
                all'Edilizia, sia pubblica che privata, nello specifico:
                <br />
                <br />
                • Acquisizione Clienti <br />
                • Gestione acquisti (materiale)
                <br />
                • Sopraluoghi
                <br />
                • Progettazione e realizzazione lavori <br />
                (assicurandone il controllo tecnico e, dove previsto, è
                responsabile sia dell'approvazione degli atti di collaudo, che
                della certificazione di regolare esecuzione delle opere).
                <br />
                • Preventivi
                <br />
                • Gestione e pianificazione cantiere
                <br />• Contabilità (SAL)
              </p>
            </div>
          </div>
        </div>

        {/* <div className="fluid-row">
          <div className="fluid-img">
            <GalleryV
              arrayFoto={["L1180197", "L1180200", "L1180219", "L1180205"]}
              titoloGallery="Impianti Elettrici"
            />
          </div>
          <div className="fluid-txt">
            <div className="fluid-content">
              <h2>Impianti Elettrici</h2>
              <p>
                Operiamo nel settore con professionalità, avvalendosi di
                personale qualificato è in grado di realizzare impianti chiavi
                in mano sia nel settore civile che industriale.
              </p>
            </div>
          </div>
        </div> */}
      </div>

      <GalleryTestata
        arrayFoto={["L1180235", "L1180228", "L1180338", "L1180341"]}
        titoloGallery="Magazzino"
      />

      <Cta />
    </div>
  );
};

export default Servizi;
